import axios from '@/api/axios'

const SNOOZES_URL = 'client/banners/snoozes'
const SNOOZE_URL = 'client/banners/snooze'

function extractBannerKeys(payload) {
  if (!Array.isArray(payload?.snoozed)) {
    return []
  }

  return payload.snoozed.map(snooze => snooze.banner)
}

export async function loadSnoozedBannerKeys() {
  try {
    const {data} = await axios.get(SNOOZES_URL)

    return extractBannerKeys(data)
  } catch {
    return []
  }
}

export function snoozeBanner(bannerKey) {
  axios.post(SNOOZE_URL, {banner: bannerKey}).catch(() => {})
}
